import { onLCP, onFCP, onINP, onCLS, LCPMetric, INPMetric, CLSMetric, FCPMetric } from "web-vitals";

const supportsEntry = (type: string) => {
  return (
    window.PerformanceObserver &&
    window.PerformanceObserver.supportedEntryTypes &&
    window.PerformanceObserver.supportedEntryTypes.includes(type)
  );
};

export const isLCPSupport = supportsEntry("largest-contentful-paint");

export const isFCPSupport = supportsEntry("paint");

export const isINPSupport = supportsEntry("event");

export const isCLSSupport = supportsEntry("layout-shift");

/**
 * WebVitals 单例类
 *
 * 缓存每项指标的 Promise / 回调结果，确保多个 Tracer 实例调用时
 * web-vitals 回调只注册一次，后续调用直接复用已有结果。
 */
class WebVitals {
  static instance: WebVitals;

  private _lcpPromise: Promise<number> | null = null;
  private _fcpPromise: Promise<number> | null = null;
  private _inpPromise: Promise<number> | null = null;
  private _clsRegistered = false;
  private _clsValue: number | null = null;
  private _clsCallbacks: Function[] = [];

  constructor() {
    if (!WebVitals.instance) {
      WebVitals.instance = this;
    }
    return WebVitals.instance;
  }
  async getLCP(): Promise<number> {
    if (!this._lcpPromise) {
      this._lcpPromise = new Promise((resolve, reject) => {
        if (!isLCPSupport) return reject(-1);
        onLCP((metric: LCPMetric) => {
          resolve(Math.round(metric.value));
        });
      });
    }
    return this._lcpPromise;
  }
  async getFCP(): Promise<number> {
    if (!this._fcpPromise) {
      this._fcpPromise = new Promise((resolve, reject) => {
        if (!isFCPSupport) return reject(-1);
        onFCP((metric: FCPMetric) => {
          resolve(Math.round(metric.value));
        });
      });
    }
    return this._fcpPromise;
  }
  async getINP(): Promise<number> {
    if (!this._inpPromise) {
      this._inpPromise = new Promise((resolve, reject) => {
        if (!isINPSupport) return reject(-1);
        onINP((metric: INPMetric) => {
          resolve(Math.round(metric.value));
        });
      });
    }
    return this._inpPromise;
  }
  // 这个指标只有在页面开始卸载后才会触发
  async getCLS(cb: Function) {
    if (!isCLSSupport) return;
    // 如果已有缓存值（指标已触发过），直接回调
    if (this._clsValue !== null) {
      cb(this._clsValue);
      return;
    }
    this._clsCallbacks.push(cb);
    if (!this._clsRegistered) {
      this._clsRegistered = true;
      onCLS((metric: CLSMetric) => {
        // https://web.dev/cls/
        // 这个值的评判标准是good: value <= 0.1 poor: value > 0.25
        // 由于insight也会对性能指标Math.round取整，这里乘以100，再做上传
        this._clsValue = Math.round(metric.value * 100);
        this._clsCallbacks.forEach((fn) => fn(this._clsValue));
        this._clsCallbacks = [];
      });
    }
  }
}

export default new WebVitals();
